<!-- eslint-disable vue/comma-dangle -->
<template>
  <div class="formwrapper">
    <form :class="['searchTourForm']">
      <div
        v-if="displayFilterCondition && condition.hasFilters"
        class="searchForm_filterBadgesArea"
      >
        <p class="searchForm_filterBadgesTitle">下記の絞り込み条件で再検索</p>
        <filter-condition-badges :condition="condition" />
      </div>
      <div :class="['searchForm_contents']">
        <departure-place-picker
          class="searchForm_departurePlace"
          :condition="condition"
          :disabled="isLoading"
          :theme="theme"
          :size="size"
          :placeholder="simplePlaceholder ? '出発地' : undefined"
          :icon="departureIcon ? 'place' : undefined"
          :put-icon-outside="putIconOutside"
          :icon-color="iconColor"
          :icon-separator="iconSeparator"
          @selected="$emit('input', $event)"
        />
        <destination-picker
          key="destination1"
          class="is-show searchForm_destination searchForm_destination_first"
          :index="0"
          :condition="condition"
          :destination-name="destinationNames[0] || ''"
          :areas="areas"
          :facets="facets"
          :theme="theme"
          :size="size"
          :placeholder="simplePlaceholder ? '目的地' : undefined"
          :icon="destinationIcon ? 'place' : undefined"
          :put-icon-outside="putIconOutside"
          :icon-color="iconColor"
          :icon-separator="iconSeparator"
          :disabled="isLoading"
          :active-tab="activeDestinationTab"
          number-of-list="1"
          @selected="$emit('input', $event)"
          @selected-auto-complete="selectDestination"
          @selected-name="selectedName($event,0)"
        />
        <destination-picker
          key="destination2"
          :class="{ 'is-show': numberOfDestinations > 1 }"
          class="searchForm_destination searchForm_destination_addition"
          :index="1"
          :condition="condition"
          :destination-name="destinationNames[1] || ''"
          :areas="areas"
          :facets="facets"
          :theme="theme"
          :size="size"
          :placeholder="simplePlaceholder ? '目的地' : undefined"
          :icon="destinationIcon ? 'place' : undefined"
          :put-icon-outside="putIconOutside"
          :icon-color="iconColor"
          :icon-separator="iconSeparator"
          :disabled="isLoading"
          :active-tab="activeDestinationTab"
          number-of-list="2"
          @selected="$emit('input', $event)"
          @selected-auto-complete="selectDestination"
          @selected-name="selectedName($event,1)"
        />
        <destination-picker
          key="destination3"
          :class="{ 'is-show': numberOfDestinations > 2 }"
          class="searchForm_destination searchForm_destination_addition"
          :index="2"
          :condition="condition"
          :destination-name="destinationNames[2] || ''"
          :areas="areas"
          :facets="facets"
          :theme="theme"
          :size="size"
          :placeholder="simplePlaceholder ? '目的地' : undefined"
          :icon="destinationIcon ? 'place' : undefined"
          :put-icon-outside="putIconOutside"
          :icon-color="iconColor"
          :icon-separator="iconSeparator"
          :disabled="isLoading"
          :active-tab="activeDestinationTab"
          number-of-list="3"
          @selected="$emit('input', $event)"
          @selected-auto-complete="selectDestination"
          @selected-name="selectedName($event,2)"
        />
        <destination-picker
          key="destination4"
          :class="{ 'is-show': numberOfDestinations > 3 }"
          class="searchForm_destination searchForm_destination_addition"
          :index="3"
          :condition="condition"
          :destination-name="destinationNames[3] || ''"
          :areas="areas"
          :facets="facets"
          :theme="theme"
          :size="size"
          :placeholder="simplePlaceholder ? '目的地' : undefined"
          :icon="destinationIcon ? 'place' : undefined"
          :put-icon-outside="putIconOutside"
          :icon-color="iconColor"
          :icon-separator="iconSeparator"
          :disabled="isLoading"
          :active-tab="activeDestinationTab"
          number-of-list="4"
          @selected="$emit('input', $event)"
          @selected-auto-complete="selectDestination"
          @selected-name="selectedName($event,3)"
        />
        <div class="add-del-buttons">
          <div class="add-destination">
            <button class="button_add-destination" :class="{ 'disable': numberOfDestinations === 4 }" type="button" :disabled="numberOfDestinations === 4" @click="addDestination">
              <svg class="form_icon icon_red" viewBox="0 0 18 18">
                <path class="filler" d="M12.63,7.88H10.52a.4.4,0,0,1-.4-.4V5.37A.39.39,0,0,0,9.73,5H8.27a.4.4,0,0,0-.4.4V7.48a.39.39,0,0,1-.39.4H5.37a.39.39,0,0,0-.4.39V9.73a.4.4,0,0,0,.4.4H7.48a.38.38,0,0,1,.39.39v2.11a.4.4,0,0,0,.4.4H9.73a.39.39,0,0,0,.39-.4V10.52a.39.39,0,0,1,.4-.39h2.11a.4.4,0,0,0,.4-.4V8.27A.39.39,0,0,0,12.63,7.88Z"/>
                <path class="filler" d="M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,15.75A6.75,6.75,0,1,1,15.75,9,6.76,6.76,0,0,1,9,15.75Z"/>
              </svg>
              <label>目的地を<br>追加</label>
            </button>
          </div>
          <div class="del-destination">
            <button class="button_del-destination" :class="{ 'disable': numberOfDestinations === 1 }" type="button" :disabled="numberOfDestinations === 1" @click="delDestination">
              <svg class="form_icon icon_gray" viewBox="0 0 512 512">
                <path class="filler" d="M359.77,224H152.23a10.73,10.73,0,0,0-10.73,10.73v42.54A10.73,10.73,0,0,0,152.23,288H359.77a10.73,10.73,0,0,0,10.73-10.73V234.73A10.73,10.73,0,0,0,359.77,224Z"/>
                <path class="filler" d="M256,0C114.61,0,0,114.62,0,256S114.61,512,256,512,512,397.39,512,256,397.38,0,256,0Zm0,448C150.13,448,64,361.87,64,256S150.13,64,256,64s192,86.13,192,192S361.87,448,256,448Z"/>
              </svg>
              <label>目的地を<br>削除</label>
            </button>
          </div>
        </div>
      </div>
      <div :class="['searchForm_contents']">
        <departure-date-picker
          class="searchForm_departureDate"
          :condition="condition"
          :disabled="isLoading"
          :min-date="minDate"
          :max-date="maxDate"
          :theme="theme"
          :size="size"
          :placeholder="simplePlaceholder ? '出発日' : undefined"
          :icon="dateIcon ? 'calendar' : undefined"
          :put-icon-outside="putIconOutside"
          :icon-color="iconColor"
          :icon-separator="iconSeparator"
          @selected="$emit('input', $event)"
        />
        <tk-pulldown
          class="searchForm_duration"
          :value="displayedDurationFrom"
          :items="selectableDurationOptions"
          :theme="theme"
          :size="size"
          :disabled="isLoading"
          @change="updateDuration($event)"
        />
        <tk-pulldown
          class="searchForm_numberOfPassengers"
          :value="displayedPassengerCount"
          :items="selectablePassengerNumberOptions"
          :theme="theme"
          :size="size"
          :text-icon="passengerIcon ? 'adults' : undefined"
          :text-icon-color="iconColor"
          :text-icon-separator="iconSeparator"
          :put-text-icon-outside="putIconOutside"
          :disabled="isLoading"
          @change="updateNumberOfPassengers($event)"
        />
        <span
          v-if="layout === 'default' && !!passengerNumberUnit"
            class="searchForm_numberOfPassengersUnit"
          >
          {{ passengerNumberUnit }}
        </span>
        <div class="searchForm_radioGroup">
          <label v-for="option in radioOptions" :key="option.value">
            <input
              v-model="selectedRadioOption"
              type="radio"
              :value="option.value"
              @change="handleRadioChange(option.value)"
            />
            {{ option.label }}
          </label>
        </div>
        <tk-button
          type="button"
          :class="['searchForm_searchButton', `-${size}`, `-${buttonColor}`]"
          :disabled="isLoading"
          @click="$emit('execute')"
        >
          <i
            aria-hidden="true"
            :class="['searchForm_searchButtonIcon']"
          ></i>
          {{ displayTourCount ? `検索する${totalTours}` : '検索' }}
        </tk-button>
      </div>
    </form>
  </div>
</template>

<script>
import { addDays, addMonths } from 'date-fns'
import { TkButton, TkPulldown } from '@ota-frontend/ui'
import DepartureDatePicker from './DepartureDatePicker'
import DeparturePlacePicker from './DeparturePlacePicker'
import DestinationPicker from './DestinationPicker'
import FilterConditionBadges from './FilterConditionBadges'
import Table from '@/api/rates'
import { Areas, DeparturePlaces, Facets, SearchCondition } from '@/models'
import { buildTourQueryFromSearchCondition, fetchBff } from '@/api'

export default {
  name: 'SearchTourForm',

  components: {
    DepartureDatePicker,
    DeparturePlacePicker,
    DestinationPicker,
    FilterConditionBadges,
    TkButton,
    TkPulldown,
  },

  model: {
    prop: 'searchCondition',
  },

  props: {
    searchCondition: {
      type: SearchCondition,
      required: true,
    },
    size: {
      type: String,
      default: 'normal',  // normal, large, x-large, xx-large, xxx-large
    },
    // フォーム部品のレイアウトプリセット
    layout: {
      type: String,
      default: 'default',  // default, compact, single-line
    },
    // 人数プルダウンの横に付ける "／１室" のような単位部分
    // layout = default の場合以外は無視される
    // 付けるか付けないか統一した方が良いのでは
    passengerNumberUnit: {
      type: String,
      default: undefined,
    },
    // 検索ボタンにツアー件数を表示するかどうか
    displayTourCount: {
      type: Boolean,
      default: false,
    },
    // placeholder を「出発地」などに変更するかどうか
    simplePlaceholder: {
      type: Boolean,
      default: false,
    },
    // 絞り込み条件を表示するかどうか
    displayFilterCondition: {
      type: Boolean,
      default: false,
    },
    selectableDurations: {
      type: Array, // of integer
      default: () => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
    },
    selectablePassengerNumbers: {
      type: Array,  // of integer
      default: () => [1, 2, 3, 4, 5, 6, 7, 8],
    },
    maxNumberOfToursToDisplay: {
      type: Number,
      default: 10000,
    },
    minDate: {
      type: Date,
      default: () => addDays(new Date(), 3),
    },
    maxDate: {
      type: Date,
      default: () => addMonths(new Date(), 20),
    },
    theme: {
      type: String,
      default: 'default',
    },
    departureIcon: {
      type: Boolean,
      default: false,
    },
    destinationIcon: {
      type: Boolean,
      default: false,
    },
    activeDestinationTab: {
      // 目的地の初期選択タブ popular-city, area が選択可能
      type: String,
      default: undefined,
    },
    dateIcon: {
      type: Boolean,
      default: false,
    },
    durationIcon: {
      type: Boolean,
      default: false,
    },
    passengerIcon: {
      type: Boolean,
      default: false,
    },
    putIconOutside: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: undefined,
    },
    iconSeparator: {
      type: String,
      default: undefined,
    },
    buttonColor: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      total: 0,
      isLoading: false,
      facets: new Facets(),
      allFacets: new Facets(),
      departurePlaces: new DeparturePlaces(),
      areas: new Areas(),
      destinationNames: [],
      firstTimeFlag: true,
      destinationViewFlag: [ true, false, false, false ],
      numberOfDestinations: 0,

      selectedRadioOption: 'null',
      radioOptions: [
        { value: 'null', label: '他の都市に行くツアーも含める' },
        { value: '2', label: '選択した都市だけに行くツアーのみ表示' },
      ],
      isInitialized: false,
    }
  },

  computed: {
    condition() {
      // facets などを上書きした condition を $emit するのはコンポーネントとして良くないかもしれない
      return this.searchCondition
        .withFacets(this.allFacets)
        .withDeparturePlaces(this.departurePlaces)
    },
    totalTours() {
      if (this.isLoading) {
        return '（- 件）'
      }
      return this.maxNumberOfToursToDisplay < this.total
        ? `（${this.maxNumberOfToursToDisplay.toLocaleString()}件以上）`
        : `（${this.total.toLocaleString()} 件）`
    },
    selectableDurationOptions() {
      return [
        {
          label: '未定',
          value: null,
        },
        ...this.selectableDurations.map((d) => ({
          label: `${d}日間`,
          value: d,
        })),
      ]
    },
    selectablePassengerNumberOptions() {
      return [
        {
          label: this.passengerNumberUnit ? '未定' : '人数',
          value: null,
        },
        ...this.selectablePassengerNumbers.map((n) => ({
          label: `${n}名`,
          value: n,
        })),
      ]
    },
    displayedDurationFrom() {
      return this.selectableDurations.includes(this.condition.durationFrom)
        ? String(this.condition.durationFrom) : null
    },
    displayedPassengerCount() {
      return this.selectablePassengerNumbers.includes(this.condition.numberOfPassengers)
        ? String(this.condition.numberOfPassengers) : null
    },
    hasSeparator1() {
      return ['single-line'].includes(this.layout)
    },
    hasSeparator2() {
      return ['single-line'].includes(this.layout)
    },
    hasSeparator3() {
      return ['single-line'].includes(this.layout)
    },
  },

  watch: {
    condition(newCondition, oldCondition) {
      !newCondition.isEqualTo(oldCondition) && this.fetchFacets()
    },
  },

  beforeMount() {
    this.initializeSearchForm()
  },

  // このライフサイクルタイミングでないとapi取得したデータを反映できないため
  updated() {
    this.firstDataLoad()
  },

  methods: {
    async initializeSearchForm() {
      this.isLoading = true
      try {
        // APIリクエストを行い、検索結果を取得
        const searchFormInfo = await fetchBff('tour/search-form', buildTourQueryFromSearchCondition(this.condition));

        // 総数やその他のデータを設定
        this.total = searchFormInfo.total;
        this.facets = new Facets(searchFormInfo.destinations);
        this.allFacets = new Facets(searchFormInfo.all_facets);
        this.departurePlaces = new DeparturePlaces(searchFormInfo.master_data.departure);
        this.areas = new Areas(searchFormInfo.master_data.area);
        this.destinationNames = searchFormInfo.requested_destination_names;
        this.numberOfDestinations = searchFormInfo.requested_destination_names.length;

        // 初回のみ URLパラメータからcondition_flgを取得
        if (!this.isInitialized) {
          const urlParams = new URLSearchParams(window.location.search);
          const conditionFlg = urlParams.get('condition_flg');
          this.selectedRadioOption = conditionFlg || 'null';
          this.isInitialized = true; // フラグを設定
        }
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
    async fetchFacets() {
      this.isLoading = true
      try {
      // APIリクエストを行い、ファセットを取得
      const searchFormInfo = await fetchBff('tour/change-search-form', buildTourQueryFromSearchCondition(this.condition))
        .catch(e => ({ total: this.total, destinations: this.facets.raw }));

        // 総数やファセットのデータを設定
        this.total = searchFormInfo.total;
        this.facets = new Facets(searchFormInfo.destinations);
        this.destinationNames = searchFormInfo.requested_destination_names;

        // URLパラメータからcondition_flgを再設定しない
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
    selectDestination(e, n) {
      this.destinationNames[n-1] = e
      // 処理タイミングの関係で一度表示がリセットされないとリフレッシュされないため、一度引っ込めてまた増やしている
      this.numberOfDestinations--
      this.numberOfDestinations++
    },
    updateDuration(duration) {
      const asNumber = duration ? Number(duration) : undefined
      this.$emit('input', this.condition.update({
        [SearchCondition.PARAMS.DURATION_FROM]: asNumber,
        [SearchCondition.PARAMS.DURATION_TO]: asNumber,
      }))
    },
    selectDuration(duration) {
      this.emittedData(duration, 'duration_from')
      this.emittedData(duration, 'duration_to')
    },
    updateNumberOfPassengers(numberOfPassengers) {
      const asNumber = numberOfPassengers ? Number(numberOfPassengers) : undefined
      this.$emit('input', this.condition.update({
        [SearchCondition.PARAMS.NUMBER_OF_PASSENGERS]: asNumber,
      }))
    },
    selectNumberOfPassengers(numberOfPassengers) {
      const asNumber = numberOfPassengers ? Number(numberOfPassengers) : undefined
      this.emittedData(asNumber, 'passenger_count')
    },
    // 初回に読み込まれた時限定の処理
    firstDataLoad() {
      if (this.firstTimeFlag === true) {
        if(this.condition.destinationCities.length < this.condition.destinationCountries.length) {
          this.condition.destinationCountries.forEach(element => {
            this.destinationNames.push(element.country_name_ja)
          });
          // this.numberOfDestinations = this.condition.destinationCountries.length
          if(this.numberOfDestinations < 1){
            this.numberOfDestinations = 1
          }
        }else {
          this.condition.destinationCities.forEach(element => {
            this.destinationNames.push(element.city_name_ja)
          });
          // this.numberOfDestinations = this.condition.destinationCities.length
          if(this.numberOfDestinations < 1){
            this.numberOfDestinations = 1
          }
        }
        this.firstTimeFlag = false
      }
    },
    // 目的地の数を増やす処理
    addDestination() {
      // 4つまでしか増やせない
      if(this.numberOfDestinations < 4){
        this.numberOfDestinations++
        this.destinationNames[this.numberOfDestinations - 1] = ''
      }
    },
    // 目的地の数を減らす処理
    delDestination() {
      // 1つまでしか減らせない
      if(this.numberOfDestinations > 1){
        this.numberOfDestinations--
        this.destinationNames[(this.numberOfDestinations)] = ''
        // 減らされる箱にデータが入っている場合、検索データからも削除する
        this.$emit(
          'input',
          this.condition.update({
            [SearchCondition.PARAMS['REGION_OF_DESTINATION'+(this.numberOfDestinations+1)]]: null,
            [SearchCondition.PARAMS['COUNTRY_OF_DESTINATION'+(this.numberOfDestinations+1)]]: null,
            [SearchCondition.PARAMS['CITY_OF_DESTINATION'+(this.numberOfDestinations+1)]]: null,
            [SearchCondition.PARAMS['DISTRICT_OF_DESTINATION'+(this.numberOfDestinations+1)]]: null,
          })
        )
      }
    },
    selectedName(labelname,number) {
      // オートコンプリートで選択したものをフォームに入れる動作。実際のフォーム制御はAPIで行われており、ここは見た目の辻褄を合わせる部分
      let found;
      if(labelname[0]!=="国全域" && labelname[0]!=="地域全域"){
        this.destinationNames[number] = labelname[0]
      }else if (labelname[0]==="国全域"){
        const countryId = labelname[1].replace('whole-country:', '')
        for(var regionkey in Table.country_list) {
          if(Table.country_list[regionkey].find( e => e.key === countryId)){
            found = Table.country_list[regionkey].find( e => e.key === countryId)
          }
        }
        this.destinationNames[number] = found.value
      }else if (labelname[0]==="地域全域"){
        const regionId = labelname[1].replace('whole-region:', '')
        found = Table.web_area_data.find( e => e.area_cd === regionId)
        this.destinationNames[number] = found.area_nm
      }
    },
    handleRadioChange(newValue) {
      this.selectedRadioOption = newValue; // ラジオボタンの選択を更新
      this.conditionFlag = newValue; // conditionFlag を更新
      const asNumber = newValue ? Number(newValue) : undefined
      this.$emit('input', this.condition.update({
        [SearchCondition.PARAMS.SEARCH_TYPE]: asNumber,
      })); // 更新を親コンポーネントに通知
    }
  },
}
</script>

<style scoped lang="scss">
.searchTourForm {
  background: white;

  &.-default {
    padding: 20px 15px;
  }

  &.-compact {
    padding: 10.5px;
  }
}

.searchForm_filterBadgesArea {
  margin-bottom: 18px;
  padding-bottom: 16px;
  border-bottom: 2px solid #dcdcdc;
}

.searchForm_filterBadgesTitle {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #347ab0;
}

.searchForm_contents {
  display: flex;
  align-items: center;
}
.searchForm_contents:nth-child(1) {
  margin-bottom: 10px;
}
.searchForm_destination {
  width: 140px;
  margin-left: 5px;
  display:none;
}
.searchForm_destination.is-show {
  display: block;
}
.searchForm_destination_first {
  width: 140px;
  margin-left: 0px;
}
.searchForm_destination_addition input  {
  left: 0 !important;
  width: 100% !important;
}
.searchForm_destination_addition .tkTextBox_icon  {
  display: none;
}

.searchForm_numberOfPassengers {
  width: 148px;
  margin-right: 6px;
}
.searchForm_duration{
  margin-left: 5px;
}
.searchForm_numberOfPassengers select {
  width: 100px !important;
  padding-left: 10px;
}
.searchForm_radioGroup{
  margin-right: 10px;
  label{
    display: block;
    & + label {
      margin-top: 5px;
    }
  }
}

.searchForm_searchButton {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border-radius: 4px;
  background-color: #f9423a;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;

  &.-x-large {
    height: 40px;
  }

  &.-blue {
    background-color: #115da1;

    &:disabled {
      color: #115da1;
    }
  }

  &:disabled {
    background-color: #d2d2d2;
    color: #f9423a;
    pointer-events: none;
  }
}

.searchForm_searchButtonIcon {
  margin-right: 0.5rem;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;

  &::before {
    content: '\f002';
  }
}
.add-del-buttons {
  display: flex;
}
.button_add-destination {
  display: flex;
  align-items: center;
  background: none;
}
.button_add-destination.disable {
  opacity: 0.3;
}
.button_add-destination label {
  line-height: 1;
  font-size: 12px;
  color: #f9423a;
  text-align: left;
}
.button_del-destination {
  display: flex;
  align-items: center;
  background: none;
}
.button_del-destination.disable {
  opacity: 0.3;
}
.button_del-destination label {
  line-height: 1;
  font-size: 12px;
  color: #63666a;
  text-align: left;
}
.form_icon {
  width: 16px;
  margin-right: 3px;
}
.icon_red .filler {
  fill: #f9423a
}
.icon_gray .filler {
  fill: #63666a
}
@media screen and (max-width: 740px) {
  .searchTourForm {
    padding: 10px;
  }
  .searchForm_contents {
    flex-wrap: wrap;
  }
  .searchForm_contents >* {
    margin-bottom: 10px;
  }
  .searchForm_departurePlace {
    width: 100%;
  }
  .searchForm_destination {
    width: 100%;
    margin-left: 0px;
  }
  .searchForm_destination_first {
    width: 100%;
    margin-left: 0px;
  }
  .searchForm_destination_addition .tkTextBox_icon  {
    display: block;
  }
  .add-del-buttons br {
    display: none;
  }
  .searchForm_departureDate {
    width: calc( (100% - 10px) / 350 * 230 );
  }
  .searchForm_duration {
    width: calc( (100% - 10px) / 350 * 120 );
  }
  .searchForm_numberOfPassengers {
    width: 160px;
  }
  .searchForm_numberOfPassengers select {
    width: 100% !important;
  }
  .searchForm_numberOfPassengers .tkPulldown_icon {
    right: 35px !important;
  }
  .searchForm_numberOfPassengersUnit {
    margin-left: 5px;
    margin-right: 20px;
  }

  .button_add-destination:active,
  .button_add-destination.active,
  .button_add-destination:focus,
  .button_add-destination:focus:active,
  .button_del-destination:active,
  .button_del-destination.active,
  .button_del-destination:focus,
  .button_del-destination:focus:active {
    opacity: 1 !important;
  }
}
</style>
